/**
 * Marca assumida da sessão STAFF (Família A do dossiê de furos).
 *
 * A sessão da casa não tem client_id — sem uma marca explícita, cada tela
 * falhava de um jeito (F-484 engolia o 422, F-491 ignorava o ?site=, F-487
 * jogava numa tela preta pós-publicação). Este store é o lugar ÚNICO onde o
 * staff assume a marca de trabalho; o seletor vive no Header e as telas leem
 * daqui como fallback quando a sessão é staff.
 *
 * Para TENANT o store é irrelevante: o backend resolve a marca pelo client_id
 * da sessão e as telas nem consultam este valor.
 */
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface MarcaAssumidaState {
  /** slug do site WordPress assumido pelo staff (null = nenhuma marca). */
  slug: string | null;
  setSlug: (slug: string | null) => void;
}

export const useMarcaAssumida = create<MarcaAssumidaState>()(
  persist(
    (set) => ({
      slug: null,
      setSlug: (slug) => set({ slug: slug || null }),
    }),
    {
      name: 'wiredesk_marca_assumida',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
